const isNil = (value) => {
  return value === void 0 || value === null;
};
const isNonNil = (value) => {
  return !isNil(value);
};
function isNumericValue(value) {
  return typeof value === "number" && !isNaN(value);
}
function isNumericString(data) {
  return !Number.isNaN(Number(data));
}
function decideBooleanFromBooleanString(booleanString) {
  return booleanString === "true";
}
function decideBooleanStringFromBoolean(bool) {
  if (bool) {
    return "true";
  }
  return "false";
}
function exhaustiveGuard(value, errorMessage) {
  throw new Error(
    errorMessage ?? `ERROR! Reached forbidden guard function with unexpected value: ${/**
     * @description 알 수 없는 값을 stringify할 때, 가장 안전한 방법을 채택함.
     * JSON.stringify 같은 건 그 자체로 또다른 throw를 일으킬 수 있음.
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/String#using_string_to_stringify_a_symbol
     */
    String(value)}`
  );
}

export { decideBooleanFromBooleanString, decideBooleanStringFromBoolean, exhaustiveGuard, isNil, isNonNil, isNumericString, isNumericValue };
//# sourceMappingURL=type.mjs.map
